import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type BadgeType = 'success' | 'warning' | 'error' | 'info' | 'neutral' | 'primary';
export type BadgeSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'app-status-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './status-badge.component.html',
  styleUrl: './status-badge.component.scss'
})
export class StatusBadgeComponent {
  @Input() label!: string;
  @Input() type: BadgeType = 'neutral';
  @Input() icon?: string;
  @Input() size: BadgeSize = 'medium';
  @Input() rounded: boolean = false; // Pill shape
  @Input() outline: boolean = false;
}
